<script src="../../../dist/static/js/app.220d2de22d9d9b08ff9e.js"></script>
<template>
  <transition name="fade">
    <div>
      <div class="flex-row absolute-center section-box section-one">
        <div style="display: flex">
          <div class="tuoy2"></div>
        </div>
        <div class="page-login flex-row absolute-center">
          <div class="login_img"></div>
          <div class="login_form flex-col flow-center">
            <h1>乐银付管理平台</h1>
            <!-- <h1>综合管理平台-2</h1> -->
            <!-- <h1>综合管理平台-3</h1> -->
            <common-el-form
              :model="formModel"
              :rules="formRules"
              @success="onSuccess"
              @keyUpEnter="keyUpEnter"
              submit-btn-text="登录"
              failTitle="登录失败"
              loadingText="登录中..."
              ref="commonElForm"
              :submitService="submitService"
              :buttonClass="false"
              :showButton="false"
            >
              <el-form-item prop="userName">
                <el-input
                  placeholder="用户名"
                  v-model.number="formModel.userName"
                  clearable
                  type="text"
                  maxlength="20"
                  autocomplete="off"
                  @clear="clearPassword"
                  ref="userNameInput"
                >
                  <i slot="prefix" class="el-input__icon icon-account"></i>
                </el-input>
              </el-form-item>
              <!-- 密码的明文与密文的切换 -->
              <el-form-item prop="passWord">
                <el-input
                  type="passWord"
                  v-model="formModel.passWord"
                  placeholder="密码"
                  clearable
                  autocomplete="off"
                >
                  <i slot="prefix" class="el-input__icon icon-lock"></i>
                </el-input>
              </el-form-item>
              <!--<el-form-item prop="passWord">-->
              <!--<el-input type="passWord" v-model="formModel.passWord" placeholder="密码" clearable-->
              <!--autocomplete="off">-->
              <!--<i slot="prefix" class="el-input__icon icon-lock"></i>-->
              <!--</el-input>-->
              <!--</el-form-item>-->
            </common-el-form>
            <p class="forgetPwd" @click="doForgetPwd">忘记密码？</p>
          </div>
        </div>
        <a
          class="copy flex-row absolute-center"
          href="http://beian.miit.gov.cn"
          target="_blank"
        >
          <img src="@/assets/images/icp.png" alt="" />
          京ICP备2023004333号-1
        </a>
        <div style="display: flex">
          <div class="tuoy4"></div>
          <div class="tuoy5"></div>
        </div>
      </div>
      <show-info-dialog
        title="温馨提示"
        ref="showInfoDialog"
        :show="true"
        dialogWidth="300px"
      >
        <p class="forget-msg">请联系管理员重置密码</p>
      </show-info-dialog>
    </div>
  </transition>
</template>


<script>
import UserService from "service/UserService";
import CommonElForm from "components/common/CommonElForm";
import FormDialog from "../dialog/FormDialog";
import ShowInfoDialog from "../dialog/ShowInfoDialog";
import StorageService from "store/interfaces";
import Device from "service/model/Device";
import Account from "service/model/Account";
import { mapActions, mapGetters } from "vuex";
import { submitMixin, sessionMixin } from "mixin";

export default {
  name: "Login",
  components: { CommonElForm, FormDialog, ShowInfoDialog },
  mixins: [submitMixin, sessionMixin],
  data() {
    return {
      formModel: {
        userName: "",
        passWord: "",
      },
      formRules: {
        userName: [
          {
            required: true,
            message: "请输入账号",
          },
        ],
        passWord: [
          {
            required: true,
            message: "请输入密码",
          },
        ],
      },
      submitService: UserService.login,
      showNav: false,
      centerDialogVisible: false,
    };
  },
  computed: {
    ...mapGetters(["nextStep"]),
  },
  mounted() {
    this.setUser(null);
    this.setToken(null);
    this.setTabBar(null);
    this.setInnerTabBar(null);
    this.setAlivePage(null);

    window.addEventListener("scroll", this.handleScroll);
    this.formModel.userName = this.loginInfo.i;
    this.formModel.passWord = this.loginInfo.p;
  },
  beforeRouteUpdate(to, from, next) {
    this.formModel.username = this.loginInfo.i;
    this.formModel.password = this.loginInfo.p;
    next();
  },
  methods: {
    alertLogin() {
      this.centerDialogVisible = true;
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.$refs.sectionTwo.offsetTop <= scrollTop) {
        this.showNav = true;
      } else {
        this.showNav = false;
      }
    },
    clearPassword() {
      this.$refs.userNameInput.focus();
      this.formModel.passWord = "";
    },
    keyUpEnter() {
      this.$refs.commonElForm.submit();
    },
    onSuccess(data) {
      if (data.respCode == "0000") {
        this.showSuccess(data.respMsg);

        // 本地缓存账号密码2小时
        // this.saveAccount(new Account({
        //     i: this.formModel.userName,
        //     p: this.formModel.passWord
        // }));

        let result = data.contents;
        // console.log('result', result);

        // 缓存token及用户信息
        // result.user.userName = 'zhou'
        this.setUser(result.user);
        this.setToken(result.token);
        this.setTabBar({
          editableTabs: [
            {
              title: "首页",
              name: "1",
              routerPath: "/index/welcome",
            },
          ],
          editableTabsValue: "1",
        });
        this.setAlivePage(["welcome"]);

        this.$router.replace({ name: "Index" });
      } else {
        this.showError(data.respMsg);
      }
    },
    doForgetPwd() {
      this.$refs.showInfoDialog.open();
    },
    ...mapActions({
      setUser: StorageService.User.setInfo,
      setToken: StorageService.User.setToken,
      setTabBar: StorageService.TabBar.setTabBar,
      setInnerTabBar: StorageService.TabBar.setInnerTabBar,
      setAlivePage: StorageService.AlivePage.setAlivePage,
    }),
  },
};
</script>

<style scoped>
.tuoy2 {
  margin-left: 13px;
  width: 60px;
  height: 30px;
  background-color: rgba(255, 255, 255);
  border-radius: 30px 0px 0px 30px;
  box-shadow: 0px 2px 8px 0px rgba(2, 35, 51, 0.2);
  z-index: -1;
  margin-top: 350px;
}
.tuoy4 {
  margin-right: 13px;
  width: 70px;
  height: 30px;
  background-color: rgba(255, 255, 255);
  border-radius: 0px 30px 30px 0px;
  box-shadow: 0px 2px 8px 0px rgba(2, 35, 51, 0.2);
  z-index: 0;
  margin-top: -200px;
}
.tuoy5 {
  width: 30px;
  height: 30px;
  background-color: rgba(255, 255, 255);
  border-radius: 50%;
  box-shadow: 0px 2px 8px 0px rgba(2, 35, 51, 0.2);
  margin-top: -200px;
}
.copy {
  width: 100%;
  text-align: center;
  line-height: 50px;
  background: rgba(3, 172, 240, 0.05);
  font-size: 16px;
  color: #aaaaaa;
  position: absolute;
  bottom: 0;
}
.copy img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.fade-enter-active {
  transition: all 0.15s;
}

.fade-enter {
  transform: scale(0.9, 0.9);
}

.page-login {
  border-radius: 20px 0px 0px 20px;
  width: 1200px;
  /*box-shadow: 0px 2px 4px 0px rgba(2, 35, 51, 0.1);*/
  box-shadow: 0px 2px 8px 0px rgba(2, 35, 51, 0.2);
}

.login_img {
  width: calc(100% - 500px);
  height: 580px;
  background: no-repeat center url("../../assets/images/login.png");
  background-size: cover;
  border-radius: 20px 0px 0px 20px;
  z-index: -2;
}

.login_form {
  width: 500px;
  height: 580px;
  background: #ffffff;
  padding: 0 100px;
  z-index: 1;
}

.login_form h1 {
  margin-bottom: 50px;
  text-align: center;
}

.section-box {
  width: 100%;
  height: 100vh;
  position: relative;
  z-index: 9;
}

.forgetPwd {
  font-size: 16px;
  font-weight: 400;
  color: #aaaaaa;
  line-height: 1;
  margin-top: 30px;
  cursor: pointer;
  text-align: center;
}

.forget-msg {
  padding: 20px 0 10px;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}

/*.section-one {*/
/*position: fixed;*/
/*top: 0;*/
/*left: 0;*/
/*background: url("../../assets/images/login.png") center/cover no-repeat;*/
/*background-attachment: fixed*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/view/page/Login.vue